/**
 * As enumerações do módulo, copiadas do catálogo da RN-10.
 *
 * Nenhuma pode ser reinterpretada: são valores gravados em produção, escritos no
 * código do legado e guardados como número. Ficou decidido que o front novo
 * **espelha** as listas e não vira cadastro — virar cadastro mexeria no banco e
 * quebraria muita coisa.
 *
 * Repare que o pinout não tem 9 nem 10: são doze tipos, não catorze.
 */

export const TIPOS_PINOUT: Record<number, string> = {
  0: "Normal",
  1: "Relé Saída",
  2: "Fusível",
  3: "Negativo 0V",
  4: "Positivo 12V",
  5: "Positivo 5V",
  6: "Sinal",
  7: "Envolto pela malha",
  8: "Ligação da malha",
  11: "Relé Entrada",
  12: "Relé Bobina",
  13: "Relé Comando",
}

export const TIPOS_CIRCUITO: Record<number, string> = {
  0: "",
  1: "Aterramento",
  2: "Negativo 0V",
  3: "Positivo 12V",
  4: "Positivo 5V",
  5: "Sinal",
  6: "Rede CANH",
  7: "Rede CANL",
  8: "Rede MSCANH",
  9: "Rede MSCANL",
  10: "Rede Serial",
  11: "Positivo Linha 30",
  12: "Positivo Linha 15",
  13: "Positivo Linha 50",
  14: "Positivo Linha Acessórios",
  15: "Sinal de Rádio",
  16: "Alta tensão",
}

/**
 * Os tipos de circuito **na ordem do legado** (`CircuitoIncluir.cshtml`): as
 * linhas 30, 15, 50 e acessórios logo depois dos positivos 12V e 5V. Em ordem
 * numérica elas iam parar depois de Rede Serial, longe do 12V, e quem procurava
 * "positivo linha 15" achava que a opção não existia.
 */
export const ORDEM_TIPOS_CIRCUITO: ReadonlyArray<readonly [number, string]> =
  [0, 1, 2, 3, 4, 11, 12, 13, 14, 5, 6, 7, 8, 9, 10, 15, 16].map((t) => [t, TIPOS_CIRCUITO[t]!] as const)

export const TIPOS_COMPONENTE: Record<number, string> = {
  0: "Normal",
  1: "Ponto de Aterramento",
  2: "Tomada de Diagnose",
  3: "Junção/Conector Intermediário",
  10: "Módulo de controle",
  11: "Ar condicionado/Arrefecimento",
  12: "Injeção Eletrônica",
  13: "Partida a Frio",
  14: "Controles da Transmissão e Tração",
  15: "Imobilizador/Partida",
}

export function rotuloTipoPinout(tipo: number): string {
  return TIPOS_PINOUT[tipo] ?? `Tipo ${tipo}`
}

/**
 * A cor de fundo do tipo na grade. Não é enfeite: separa alimentação de sinal e
 * de malha à distância, que é o que o olho procura ao varrer duzentas linhas.
 * "Normal" é a maioria absoluta e por isso não ganha cor nenhuma — pintar tudo
 * é o mesmo que não pintar nada.
 */
export function tomDoTipo(tipo: number): { fundo: string; texto: string } | null {
  switch (tipo) {
    case 3: // Negativo 0V
      return { fundo: "var(--surface3)", texto: "var(--txt2)" }
    case 4: // Positivo 12V
    case 5: // Positivo 5V
      return { fundo: "var(--acao-soft)", texto: "var(--acao-on-soft)" }
    case 6: // Sinal
      return { fundo: "var(--brand-soft)", texto: "var(--brand-on-soft)" }
    case 1: // Relé Saída
    case 11: // Relé Entrada
    case 12: // Relé Bobina
    case 13: // Relé Comando
    case 2: // Fusível
      return { fundo: "var(--ok-soft)", texto: "var(--ok-on-soft)" }
    case 7: // Envolto pela malha
    case 8: // Ligação da malha
      return { fundo: "var(--surface3)", texto: "var(--txt2)" }
    default:
      return null
  }
}
